(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_1ebd09c"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) { var button = event.target.closest('[data-youtube-play]'); if (!button) return; var embed = button.closest('[data-youtube-embed]'); if (!embed) return; var frame = embed.querySelector('[data-youtube-frame]'); if (!frame) return; frame.src = frame.dataset.src; frame.hidden = false; button.hidden = true; });
  } catch(e) { console.error(e); }
})();

})();
